import {
  Checkbox as ChakraCheckbox,
  CheckboxProps,
  forwardRef,
} from '@chakra-ui/react';

import { getCheckboxIcon } from './Checkbox.utils';

export interface ICheckboxProps extends CheckboxProps {
  leftIcon?: React.ReactElement;
  rightIcon?: React.ReactElement;
  trackId?: string;
}

/**
 * I have not found a way to override default icons without wrapping the
 * component, styles come from styles/components/Checkbox, adjustments
 * are to me made there.
 */
export const Checkbox = forwardRef<ICheckboxProps, 'div'>(
  ({ children, leftIcon, rightIcon, trackId, ...props }, ref) => (
    <ChakraCheckbox
      icon={getCheckboxIcon(props)}
      ref={ref}
      track-id={trackId}
      {...props}
    >
      {leftIcon} {children} {rightIcon}
    </ChakraCheckbox>
  ),
);
